export const red = "#EF4D63";
export const blue = "#2575BC";
export const green = "#1EB26A";
export const yellow = "#EE9F46";
export const mainBg = "#D66039";
export const mainColor = "#DD4236";
